import React, { useContext } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import currency from 'currency.js';
import { Tooltip } from '@chakra-ui/react';
import useTaxValue from '../hooks/useTaxValue';
import { StoreContext } from '../context/Store';
import { jsx as ___EmotionJSX } from "@emotion/react";
const PriceTag = _ref => {
  let {
    price,
    priceRange,
    showMwst,
    showInfo,
    priceNetto,
    replaceZero
  } = _ref;
  const {
    settings
  } = useContext(StoreContext);
  const {
    taxPercentage,
    taxValue,
    priceBrutto
  } = useTaxValue(price, settings.data.default_tax_percent);
  if (settings.data.default_tax_percent === 0) {
    showInfo = false;
  }
  if (replaceZero && price === 0) {
    return ___EmotionJSX(React.Fragment, null, "Preis auf Anfrage");
  }
  if (!price && priceRange) {
    return ___EmotionJSX(React.Fragment, null, priceRange.map((price, index) => {
      return ___EmotionJSX(React.Fragment, {
        key: price
      }, currency(price, {
        symbol: '€',
        separator: '.',
        decimal: ',',
        pattern: '# !'
      }).format(), priceRange.length > 1 && index === priceRange.length - 2 && ___EmotionJSX(React.Fragment, null, "\xA0-\xA0"));
    }), showInfo && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Tooltip, {
      label: `Inkl. ${taxPercentage}% Mehrwertsteuer`
    }, ___EmotionJSX("span", null, ___EmotionJSX(FaInfoCircle, {
      style: {
        verticalAlign: 'middle',
        marginLeft: '10px'
      }
    })))));
  }
  if (typeof priceNetto === 'number') {
    return ___EmotionJSX(React.Fragment, null, currency(priceNetto, {
      symbol: '€',
      separator: '.',
      decimal: ',',
      pattern: '# !'
    }).format());
  }
  if (price && showMwst) {
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(React.Fragment, null, currency(taxValue, {
      symbol: '€',
      separator: '.',
      decimal: ',',
      pattern: '# !'
    }).format()), showInfo && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Tooltip, {
      label: `${taxPercentage}%`
    }, ___EmotionJSX("span", null, ___EmotionJSX(FaInfoCircle, {
      style: {
        verticalAlign: 'middle',
        marginLeft: '10px'
      }
    })))));
  } else {
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(React.Fragment, null, currency(priceBrutto, {
      symbol: '€',
      separator: '.',
      decimal: ',',
      pattern: '# !'
    }).format()), showInfo && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Tooltip, {
      label: `Inkl. ${taxPercentage}% Mehrwertsteuer`
    }, ___EmotionJSX("span", null, ___EmotionJSX(FaInfoCircle, {
      style: {
        verticalAlign: 'middle',
        marginLeft: '10px'
      }
    })))));
  }
};
PriceTag.defaultProps = {
  showInfo: true,
  replaceZero: true
};
export default PriceTag;